<section *ngIf="showPromo && pageData">
    <span class="body" [innerHtml]="pageData.body"></span>
    <button class="pricing-info" type="button" [attr.aria-label]="pageData.pricingInfoModal.buttonAriaLabel" (click)="viewModal()" [innerHtml]="pageData.pricingInfoText"></button>
</section>
